export enum CrudValidationGroups {
    CREATE = "CRUD-CREATE",
    UPDATE = "CRUD-UPDATE"
}
